import { IconProps } from '../Icon.types';

export const StatusInProgressIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 16 16">
      <rect width="16" height="16" rx="8" />
      <path
        d="M8 4.5C8.276 4.5 8.5 4.724 8.5 5V9.5C8.5 9.776 8.276 10 8 10C7.724 10 7.5 9.776 7.5 9.5V5C7.5 4.724 7.724 4.5 8 4.5Z"
        fill="white"
      />
      <path
        d="M8 12C8.414 12 8.75 11.664 8.75 11.25C8.75 10.836 8.414 10.5 8 10.5C7.586 10.5 7.25 10.836 7.25 11.25C7.25 11.664 7.586 12 8 12Z"
        fill="white"
      />
    </svg>
  );
};
